import { setToken } from 'utils/setToken'
import { pushRoute } from './pushRoute'

export const setTokenAndPushRoute = (token: string, uri: string) => {
  setToken(token)

  pushRoute(uri)
}
